import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';

export const ReferenceLineSchema = new GenericModelSchema('referenceLine', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    name: StringProperty,
  },
});
